import { Text } from '../text'

export function ErrorPage() {
  return <Text size={14}>오류가 발생했습니다. 다시 시도해주세요</Text>
}
